import Avatar from './avatar';
import AvatarName from './avatar-name';
import determineIfMobile from '@homeaway/react-determine-if-mobile';
import React from 'react';
import Tooltip from '@homeaway/react-tooltip';
import './avatar-cluster.less';

export const getKey = (profile, idx) => {
    const first = profile && profile.firstName;
    if (first) {
        return `${first.toLowerCase()}-${idx || 0}`;
    }
    return '';
};

// handle null profiles + pluck out last 3 profiles and
// display the most recent profile "on top" of the cluster
export const sort = (profiles = []) => {
    const filtered = profiles.filter((profile) => profile).reverse();
    filtered.splice(3);
    return filtered.reverse();
};

export function AvatarNames({profiles, showAvatar = false, sm = false}) {
    if (Array.isArray(profiles) && profiles.length) {
        return (
            <ul className="avatar-names">
                {profiles.map((profile, idx) => {
                    // filter out null profiles
                    if (!profile || !profile.firstName) {
                        return null;
                    }
                    return (
                        <li className="avatar-names__profile" key={getKey(profile, idx)}>
                            {showAvatar && <Avatar {...profile} sm={sm} />}
                            <AvatarName {...profile} />
                            <br />
                        </li>
                    );
                })}
            </ul>
        );
    }
    return null;
}

export function AvatarCluster({
    className,
    isMobile,
    onClose,
    onOpen,
    profiles,
    showAvatar,
    sm
}) {
    if (Array.isArray(profiles) && profiles.length) {
        const placement = isMobile ? 'top' : 'bottom';
        const trigger = 'click';
        const users = sort(profiles);
        return (
            <Tooltip
                content={<AvatarNames profiles={profiles} showAvatar={showAvatar} sm={sm} />}
                placement={placement}
                onClose={onClose}
                onOpen={onOpen}
                tooltipType="popover"
                trigger={trigger}
            >
                <div className={`avatar-cluster ${className || ''}`}>
                    {users.map((profile, idx) => (
                        <Avatar key={getKey(profile, idx)} {...profile} sm={sm} />
                    ))}
                </div>
            </Tooltip>
        );
    }
    return null;
}

AvatarCluster.defaultProps = {
    isMobile: true,
    onClose: () => {},
    onOpen: () => {},
    profiles: [],
    sm: false
};

export default determineIfMobile(AvatarCluster);


// WEBPACK FOOTER //
// ./src/universal/tripboard/avatar/avatar-cluster.js